<div id="wrap" class="moWrap m_event_wrap event_openPromotion_241101">
    <header class="header">
        <div class="header_inner">
            <h1 class="header_logo">
                <a href="" class="logo"><img src="/assets/images/web/logo/logo_348.png" alt="OASIS BUDDY" /></a>
            </h1>
            <span class="util_right">
                <a href="https://www.oasis.co.kr" target="_blank" class="btn_oasis ico_blank">오아시스마켓</a>
            </span>
        </div>
    </header>

    <div class="bannerTop">
        <h2><img src="https://oasisprodcom.edge.naverncp.com/buddy/event/openPromotion_241101/mobile/banner_visual.jpg" alt="건강한 먹거리로 장보고! 나만의 식품컨텐츠로 리워드도 받고! / 오아시스마켓 버디 모집. 웰컴혜택 2만 포인트 보장 / *수수료 최대 5%(익월 정산) / 조기마감될 수 있습니다."></h2>
    </div>
    <div class="tabsMenuConts">
      <div class="moveTab">
          <div class="innerBox">
              <div class="inner">
                  <button type="button" [ngClass]="visible1 ? 'active' : ''" (click)="moveTab('oAnchorCont1')">오아시스버디</button>
                  <button type="button" [ngClass]="visible2 ? 'active' : ''" (click)="moveTab('oAnchorCont2')">2만 포인트 받기</button>
                  <button type="button" [ngClass]="visible3 ? 'active' : ''" (click)="moveTab('oAnchorCont3')">50만 슈퍼보너스</button>
              </div>
          </div>
      </div>
        <div class="tabConts">
            <!-- content1 -->
            <div class="conts cont1 tabUse" id="oAnchorCont1">
                <h2><img src="https://oasisprodcom.edge.naverncp.com/buddy/event/openPromotion_241101/mobile/img_cont1.jpg" /></h2>
                <div class="blind">
                    <strong>장보기 라이프를 공유만 해도 수익이? OASIS BUDDY</strong>
                    <p>오아시스버디란? 컨텐츠 창작자들이 오아시스마켓 식품을 홍보하고 수익을 창출할 수 있는 최고의 비즈니스 플랫폼입니다.</p>
                    <strong>오아시스버디만의 특별한 혜택 안내</strong>
                    <ul>
                      <li>수수료 최대 5%</li>
                      <li>익월 정산 시스템</li>
                      <li>전용 계약 가능</li>
                      <li>채널 및 컨텐츠 홍보</li>
                    </ul>
                    <ul>
                      <li>오아시스버디에 가입 후 SNS 게시물에 오아시스마켓과 관련된 자유로운 컨텐츠를 올리고 깅크만 올려주면 끝!</li>
                      <li>링크를 통해 상품 판매가 이루어지면 구매액의 최대 5% 수수료를 얻을 수 있습니다.</li>
                      <li>방문자가 마지막으로 클릭한 ㄹ이크를 기준으로 24시간 내 구매한 모든 건에 대해 수익 제공.</li>
                    </ul>
                </div>
            </div>
            <!-- //content1 -->
            <!-- content2 -->
            <div class="conts cont2" id="oAnchorCont2">
                <div class="cont_pos">
                  <img src="https://oasisprodcom.edge.naverncp.com/buddy/event/openPromotion_241101/mobile/img_cont2_1.jpg">
                  <div class="evBtn_flexBox">
                    <a href="https://www.oasis.co.kr/join/list" target="_blank" class="btn_1"><span class="blind">오아시스마켓 가입하기</span></a>
                    <a (click)="moveJoin()" class="btn_2"><span class="blind">버디 가입하기</span></a>
                    <input type="text" [(ngModel)]="snsUrl" (focus)="checkToken()" placeholder="https://" class="btn_3" />
                    <button type="button" (click)="eventAttend()" class="btn_4"><span class="blind">등록하기</span></button>
                  </div>
                </div>
                <div class="cont_pos">
                  <img *ngIf="attendListSize == 0" src="https://oasisprodcom.edge.naverncp.com/buddy/event/openPromotion_241101/mobile/img_cont2_2.jpg">
                  <img *ngIf="attendListSize == 1" src="https://oasisprodcom.edge.naverncp.com/buddy/event/openPromotion_241101/mobile/img_cont2_2_1st.jpg"><!-- 첫번쨰 응모 시 노출 -->
                  <img *ngIf="attendListSize == 2" src="https://oasisprodcom.edge.naverncp.com/buddy/event/openPromotion_241101/mobile/img_cont2_2_2nd.jpg"><!-- 두번쨰 응모 시 노출 -->
                  <img *ngIf="attendListSize == 3" src="https://oasisprodcom.edge.naverncp.com/buddy/event/openPromotion_241101/mobile/img_cont2_2_3rd.jpg"><!-- 세번쨰 응모 시 노출 -->
                </div>
                <div class="cont_toggle">
                  <input type="checkbox" id="showYn" class="blind" />
                  <label for="showYn">
                    <img src="https://oasisprodcom.edge.naverncp.com/buddy/event/openPromotion_241101/mobile/img_cont2_3_show.jpg" class="show">
                    <img src="https://oasisprodcom.edge.naverncp.com/buddy/event/openPromotion_241101/mobile/img_cont2_3_hide.jpg" class="hide">
                  </label>
                </div>
                <div class="blind">
                  <strong>EVENT 01</strong>
                  <strong>버디 챌린지 성공하면 최대 2만 포인트 보장</strong>
                  <p>런칭 기념으로 진행되는 웰컴 이벤트를 준비했어요! 쉽고 빠르게 참여 가능한 챌린지 시작해보세요</p>
                  <span>기간: 2024년 11월 1일 금요일부터 2024년 12월 31일 화요일까지</span>
                  <ol>
                    <li>
                      <strong>STEP 1</strong>
                      <p>오아시스마켓 회원가입부터! 가입 즉시 10,000원 할인쿠폰을 드려요</p>
                      <div class="evBtn_flexBox">
                        <a href="https://www.oasis.co.kr/join/list" target="_blank"><span class="blind">오아시스마켓 가입하기</span></a>
                      </div>
                    </li>
                    <li>
                      <strong>STEP 2</strong>
                      <p>챌린지하고 2만 포인트 받기</p>
                      <ol>
                        <li>1. 오아시스버디 회원가입해 주세요. <a href=""><span class="blind">버디 가입하기</span></a></li>
                        <li>2. SNS에 오아시스마켓 컨텐츠를 작성해 주세요. 컨텐츠 주제는 자유롭게 가능해요(추천템, 이용후기 등) * 사진 3장 이상 또는 영상 1개 이상, 글자수 500자 이상</li>
                        <li>3. <strong>#오아시스버디챌린지</strong> 태그를 꼭! 달아주세요.</li>
                        <li>4. 아래 링크를 입력하고 등록하기 버튼을 눌러주세요.</li>
                      </ol>
                    </li>
                    <li>
                      <strong>STEP 3</strong>
                      <p>URL 입력하기</p>
                      <input type="text" />

                    </li>
                  </ol>

                </div>
            </div>
            <!-- //content2 -->
            <!-- content3 -->
            <div class="conts cont3" id="oAnchorCont3">
                <h2><img src="https://oasisprodcom.edge.naverncp.com/buddy/event/openPromotion_241101/mobile/img_cont3.jpg"></h2>
                <div class="blind">
                  <strong>EVENT 02</strong>
                  <strong>챌린지 3회 성공 후 3분에게 슈퍼 보너스 지급!</strong>
                  <p>주제에 맞는 컨텐츠를 가장 정성스럽게 담아주신 3분께 슈퍼 보너스를 쏩니다!</p>
                  <p>컨텐 3회 달성을 모두 완료하신 분들에 한해서 자동으로 응모됩니다.</p>
                  <strong>당첨자 발표: 2024년 1월 6일 월요일, 개별연락</strong>
                  <ul>
                    <li>1등 당첨자 : 오아시스마켓 포인트 25만원</li>
                    <li>2등 당첨자 : 오아시스마켓 포인트 15만원</li>
                    <li>3등 당첨자 : 오아시스마켓 포인트 10만원</li>
                  </ul>
                  <p>선정 확률 UP! 식품 등 콘텐츠 관련 활발한 SNS를 운영하는 분, 오아시스마켓 상품을 구매하고 다양한 사람들과 공유하는 분</p>
                </div>
            </div>
            <!-- //content3 -->
            <!-- content4 -->
            <div class="conts cont4" id="oAnchorCont4">
                <h2><img src="https://oasisprodcom.edge.naverncp.com/buddy/event/openPromotion_241101/mobile/img_cont4.jpg"></h2>
                <div class="blind">
                  <strong>오아시스버디 등급별 혜택 안내</strong>
                  <ul>
                    <li>
                      <strong>이웃등급</strong>
                      <span>구매 금액의 3%를 리워드로 제공</span>
                      <p>유튜브 구독자 100명 이상, 인스타그램 팔로워 300명 이상, 네이버 블로그 개설일 90일 이상 조건 중 1개 이상 해당되는 계정</p>
                    </li>
                    <li>
                      <strong>파워등급</strong>
                      <span>구매 금액의 5%를 리워드로 제공</span>
                      <p>유튜브 구독자 1,000명 이상, 인스타그램 팔로워 1,000명 이상, 네이버 블로그 개설일 90일 이상+네이버 브로그 일 평균 방문자 1,000명 이상 조건 중 1개 이상 해당되는 계정</p>
                    </li>
                  </ul>
                </div>
            </div>
            <!-- //content4 -->
        </div>
    </div>

    <footer class="footer">
        <div class="footer_inner">
            <div class="footer_menu">
                <a routerLink="/guide">이용가이드</a>
                <a href="https://www.oasis.co.kr/help/privacy" target="_blank" title="새창" class="emphasis">개인정보처리방침</a>
                <a routerLink="/terms">약관 및 정책</a>
            </div>
        </div>
    </footer>
  </div>
